var uiAssetClassBadge = {
	bond: "Bond",
	commodity: "Commodity",
	currency: "Currency",
	debt: "Debt",
	etf: "ETF",
	fund: "Fund",
	generic: "Generic",
	index: "Index",
	stock: "Stock",
	interestRate: "Interest Rate",
	structuredProduct: "Structured Product",
	investmentProduct: "Investment Product",
	leveragedProduct: "Leveraged Product",
	future: "Future",
	option: "Option"
};
var en = {
	uiAssetClassBadge: uiAssetClassBadge
};

export { en as default, uiAssetClassBadge };
